import { Box, Button, Paper, TextField, useTheme } from "@mui/material";
import Headers from "../../components/Headers";

import { useTemplateStore, useLoginStore } from "../../Utils/Store";
import { Formik } from "formik";
import * as yup from "yup";
import { tokens } from "../../theme";

const AddTemplate = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const addTemplate = useTemplateStore((state) => state.addTemplate);

  const isLogin = useLoginStore((state) => state.isLogin);

  const initialValues = {
    description: "",
  };

  const checkoutSchema = yup.object().shape({
    description: yup.string().required("required"),
  });

  return (
    <Box m="20px">
      <Paper
        elevation={0}
        sx={{ borderRadius: "10px", background: colors.primary[400] }}
      >
        <Headers title="Add Template" />
      </Paper>
      <Paper
        elevation={0}
        sx={{
          borderRadius: "10px",
          padding: "10px",
          background: colors.primary[400],
        }}
      >
        <Formik
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            let payload = {
              description: values.description,
              user_id: isLogin.id,
            };
            await addTemplate(payload);
            setSubmitting(false);
            alert("Template added successfully!");
            resetForm();
          }}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box height="70vh">
                <TextField
                  fullWidth
                  type="text"
                  label="Description"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.description}
                  name="description"
                  error={!!touched.description && !!errors.description}
                  helperText={touched.description && errors.description}
                  sx={{ gridColumn: "span 2" }}
                  multiline
                  rows={15}
                />
                <Box display="flex" justifyContent="end" mt="20px">
                  <Button
                    type="submit"
                    color="secondary"
                    variant="contained"
                    disabled={isSubmitting}
                  >
                    Create New Template
                  </Button>
                </Box>
              </Box>
            </form>
          )}
        </Formik>
      </Paper>
    </Box>
  );
};

export default AddTemplate;
